module.exports = __webpack_public_path__ + "img/logo.eb4e96ff.png";